import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavbarFour = _resolveComponent("NavbarFour")!
  const _component_MainBanner = _resolveComponent("MainBanner")!
  const _component_LatestMovies = _resolveComponent("LatestMovies")!
  const _component_WhatMakesUsDifferent = _resolveComponent("WhatMakesUsDifferent")!
  const _component_MoreToStream = _resolveComponent("MoreToStream")!
  const _component_ThatMadeForYou = _resolveComponent("ThatMadeForYou")!
  const _component_CustomizeYourExperience = _resolveComponent("CustomizeYourExperience")!
  const _component_PricingPlans = _resolveComponent("PricingPlans")!
  const _component_OurReviews = _resolveComponent("OurReviews")!
  const _component_FrequentlyAskedQuestions = _resolveComponent("FrequentlyAskedQuestions")!
  const _component_SubscribeNow = _resolveComponent("SubscribeNow")!
  const _component_MainFooter = _resolveComponent("MainFooter")!
  const _component_CopyRight = _resolveComponent("CopyRight")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_NavbarFour, {
      class: "ott-platform-navbar",
      className: "container mw-1685",
      autoStyle: "ms-auto"
    }),
    _createVNode(_component_MainBanner),
    _createVNode(_component_LatestMovies),
    _createVNode(_component_WhatMakesUsDifferent),
    _createVNode(_component_MoreToStream),
    _createVNode(_component_ThatMadeForYou),
    _createVNode(_component_CustomizeYourExperience),
    _createVNode(_component_PricingPlans),
    _createVNode(_component_OurReviews),
    _createVNode(_component_FrequentlyAskedQuestions),
    _createVNode(_component_SubscribeNow),
    _createVNode(_component_MainFooter, {
      class: "bg-secondary bg-img",
      style: _normalizeStyle({ backgroundImage: `url(${_ctx.bgImage})` })
    }, null, 8, ["style"]),
    _createVNode(_component_CopyRight)
  ], 64))
}